<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import { ScreenshotActionService } from './ScreenshotAction.service';

const screenshotActionService = useService(ScreenshotActionService);
</script>

<template>
  <div v-show="screenshotActionService.visible">截图</div>
</template>
